/**
 * @description: 相差天数计算
 * @return {*}
 */
export const dateCountDays = (last: number, next: number) => {
  try {
    let _last = last;
    let _next = next;
    const dayTimeStamp = 1000 * 60 * 60 * 24;
    if ((last + '').length === 10) {
      _last = last * 1000;
    }
    if ((next + '').length === 10) {
      _next = next * 1000;
    }
    return Math.round(Math.abs(_last - _next) / dayTimeStamp);
  } catch (error) {
    return 0;
  }
};
